import { defaultHttpClient } from '../../httpClient';
import type { PostTrackingLinksAccessLogsRequest } from './types';

export const postTrackingLinksAccessLogs = (
  data: PostTrackingLinksAccessLogsRequest,
) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: '/api/v2/tracking-links/access-logs/',
      data,
    })
    .then(result => result.data);
};
